import { render, staticRenderFns } from "./lyinfo.vue?vue&type=template&id=36f68191&scoped=true&"
import script from "./lyinfo.vue?vue&type=script&lang=js&"
export * from "./lyinfo.vue?vue&type=script&lang=js&"
import style0 from "./lyinfo.vue?vue&type=style&index=0&id=36f68191&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f68191",
  null
  
)

export default component.exports